/* React Higher Order Component which provides children with current SignInStore state
    Child (InnerComponent) will always render
    child will receive props: {
        signInStoreState: PropTypes.object,
    }
*/

import React from 'react';
import PropTypes from 'prop-types';

const SignInStore = require('../../stores/SignInStore');
const ReactUtil = require('../../util/ReactUtil');

const propTypes = {};
const defaultProps = {};

export default function withSignInStoreState(WrappedComponent) {
    class WithSignInStoreState extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                signInStoreState: SignInStore.getState(),
            }

            this.unsubscribes = [SignInStore.listen(this.onSignInStoreChange.bind(this))];
        }

        componentWillUnmount() {
            this.unsubscribes.forEach(u => u());
        }

        onSignInStoreChange(state) {
            this.setState({ signInStoreState: state });
        }

        render() {
            return (
                <WrappedComponent
                    {...this.props}
                    signInStoreState={this.state.signInStoreState}
                />
            );
        }
    }

    WithSignInStoreState.propTypes = propTypes;
    WithSignInStoreState.defaultProps = defaultProps;
    WithSignInStoreState.displayName = `WithSignInStoreState(${ReactUtil.getComponentDisplayName(WrappedComponent)})`
    return WithSignInStoreState;
}